<template>
    <v-row class="justify-center align-center login mx-0">
        <v-card outlined class="form-card border-transparent">
            <h1>{{ metaData.header }}</h1>
            <h3>{{ $t('loginWelcomeMessage')}}</h3>
            <login-form :router-back="false" @login-success="loginSuccess"></login-form>
        </v-card>
    </v-row>
</template>

<script>
    import LoginForm from '../../../app-front/components/forms/login-form';

    export default {
        name: "Login",
        data() {
            return {
                metaUrl: '/login',

            }
        },
        components: {LoginForm},
        methods: {
            loginSuccess() {
                if(!window.authRedirectCredentials) {
                    this.$router.push('/profile/personal-info');
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    h3 {
        text-align: center;
    }

    label {
        padding-left: 10px;
    }

    .row .col-12 {
        padding-top:6px;
        padding-bottom:6px;
    }
</style>
